import script from "./SampleUI.vue?vue&type=script&setup=true&lang=js"
export * from "./SampleUI.vue?vue&type=script&setup=true&lang=js"

import "./SampleUI.vue?vue&type=style&index=0&id=5ed280c6&lang=postcss&scoped=true"

import exportComponent from "/builds/atlatl-software/atlatl-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ed280c6"]])

export default __exports__